/* Footer simples - só informação para fechar a página */
export default function Footer() {
  return (
    <footer className="footer">
      <small>LearnFlix — Projeto de Bloco • 2025</small>
    </footer>
  );
}
